// extracted by mini-css-extract-plugin
export default {"nav-list":"Tabs_nav-list__16a-9","nav-item":"Tabs_nav-item__uB7xc","active":"Tabs_active__zgmK+","pending":"Tabs_pending__F9zev","disabled":"Tabs_disabled__Io0xW"};